<template>
  <div class="devise-wrap" >
    <div class="top-wrap">
      <div class="top-context">
        <div class="context-top">
          <div class="left-png">“</div>
          <div class="left-words">Ruize Design：专注数字化产品设计服务</div>
          <div class="left-hello">
            <img src="@/assets/solutions/hello.png" alt="">
          </div>
        </div>
        <div class="context-center">睿泽设计服务上线啦</div>
        <div class="context-bottom">
          <div class="bottom-english">RuizeDesign Grand Open!</div>
          <div class="bottom-png">”</div>
        </div>
      </div>
    </div>
    <div class="devise-Wrap">
      <div class="my-devise">
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/UI.png" alt="">
          </div>
          <div class="item-title">UI设计</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/plane.png" alt="">
          </div>
          <div class="item-title">平面设计</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/video.png" alt="">
          </div>
          <div class="item-title">视频设计</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/brand.png" alt="">
          </div>
          <div class="item-title">品牌</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/Industry.png" alt="">
          </div>
          <div class="item-title">工业设计</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/packaging.png" alt="">
          </div>
          <div class="item-title">包装设计</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/illustration.png" alt="">
          </div>
          <div class="item-title">插画设计</div>
        </div>
        <div class="my-devise-item">
          <div class="item-png">
            <img src="@/assets/solutions/advertisement.png" alt="">
          </div>
          <div class="item-title">广告设计</div>
        </div>
      </div>
    </div>
    <div class="my-offer">
      <div class="my-offer-top">我们提供的服务</div>
      <div class="my-offer-footer">
        <div class="context">我们的设计服务范围包括但不限于：APP/小程序界面、网站界面、品牌LOGO、IP形象、包装、VI/CI标志、DM/宣传单/平面广告、海报、手绘插画、</div>
        <div class="context">3D运营海报、画册、PPT、剪辑视频、合成视频、特效视频、MG动画、三维动画、工业设计等</div>
      </div>
    </div>
    <div class="my-hover">
      <div class="my-hover-wrap">
        <div class="my-hover-left">
          <div class="hover-wrap">
            <div class="hover-left-title">Digitization</div>
            <div class="hover-left-num">数字化产品设计</div>
            <div class="hover-left-context">以“人“为核心，梳理产品需求，洞察产品痛点，多维度分析验证产品设想，让设计落地，打造全新产品力与品牌力。</div>
            <div class="hover-left-context">赋能企业数字化转型，帮助企业规划业务流程创新、用户体验创新，信息化跨平台系统设计等，从而实现降本提效。</div>
          </div>
        </div>
        <div class="my-hover-right">
          <div class="hover-right-item left">
            <!-- <div class="right-item user"> -->
            <div :class="`right-item user ${index==='1'? 'user_hov' : ''}`" @mouseover="index='1'" >
              <div class="hover-icon user-small" :style="`display: ${index === '1' ? 'none' : 'block'};margin-top: 105px`">
                <img src="@/assets/solutions/user.png" alt="">
              </div>
              <div class="hover-context user-small" :style="`display: ${index === '1' ? 'none' : 'block'};margin-top: 105px`">
                <div class="hover-context-top">用户研究</div>
                <div class="hover-context-bottom">根据具体项目要求进行需求分析，趋势分析，竞争性分析，用户研究，以便提供适当的解决方案。</div>
              </div>
              <div class="big user-big" :style="`display: ${index === '1' ? 'block' : 'none'}`">
                <div class="a-top">用户研究</div>
                <div class="a-bottom">根据具体项目要求进行需求分析，趋势分析，竞争性分析，用户研究，以便提供适当的解决方案。</div>
              </div>
            </div>
            <div :class="`right-item vision ${index==='2'? 'vision_hov' : ''}`" @mouseover="index='2'">
              <div class="hover-icon vision-small" :style="`display: ${index === '2' ? 'none' : 'block'}`">
                <img src="@/assets/solutions/vision.png" alt="">
              </div>
              <div class="hover-context vision-small" :style="`display: ${index === '2' ? 'none' : 'block'};`">
                <div class="hover-context-top">视觉设计</div>
                <div class="hover-context-bottom">用艺术家的视野为产品赋予灵性和美感，从每一个细节入手，为用户提供舒适的视觉体验。</div>
              </div>
              <div class="big vision-big" :style="`display: ${index === '2' ? 'block' : 'none'}`" >
              <div class="a-top">视觉设计</div>
              <div class="a-bottom">用艺术家的视野为产品赋予灵性和美感，从每一个细节入手，为用户提供舒适的视觉体验。</div></div>
            </div>
          </div>
          <div class="hover-right-item right">
            <div :class="`right-item interactive ${index==='3'? 'interactive_hov' : ''}`" @mouseover="index='3'">
              <div class="hover-icon interactive-small" :style="`display: ${index === '3' ? 'none' : 'block'};margin-top: 105px`">
                <img src="@/assets/solutions/interactive.png" alt="">
              </div>
              <div class="hover-context interactive-small" :style="`display: ${index === '3' ? 'none' : 'block'};margin-top: 105px`" >
                <div class="hover-context-top">交互设计</div>
                <div class="hover-context-bottom">梳理重构产品信息架构以保证产品逻辑架构清晰易用，并通过建立系统的交互设计规范来达成产品体验的严谨一致性。</div>
              </div>
              <div class="big interactive-big" :style="`display: ${index === '3' ? 'block' : 'none'}`">
                <div class="a-top">交互设计</div>
                <div class="a-bottom">梳理重构产品信息架构以保证产品逻辑架构清晰易用，并通过建立系统的交互设计规范来达成产品体验的严谨一致性。</div>
              </div>
            </div>
            <div :class="`right-item implement ${index==='4'? 'implement_hov' : ''}`" @mouseover="index='4'">
              <div class="hover-icon implement-small" :style="`display: ${index === '4' ? 'none' : 'block'}`">
                <img src="@/assets/solutions/implement.png" alt="">
              </div>
              <div class="hover-context implement-small" :style="`display: ${index === '4' ? 'none' : 'block'}`">
                <div class="hover-context-top">项目执行</div>
                <div class="hover-context-bottom">我们用12年的项目经验来帮助开发团队最大限度的在产品中还原设计效果，请记住，这点至关重要。</div>
              </div>
              <div class="big implement-big" :style="`display: ${index === '4' ? 'block' : 'none'}`">
                <div class="a-top">项目执行</div>
                <div class="a-bottom">我们用12年的项目经验来帮助开发团队最大限度的在产品中还原设计效果，请记住，这点至关重要。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-offer">
      <div class="my-offer-tops">全流程界面解决方案</div>
      <div class="my-offer-footer">
        <div class="context">我们洞察客户所在行业与业务场景，提供极具竞争力的定制设计方案</div>
        <div class="context">赋能企业数字化转型，帮助您规划业务流程创新、用户体验创新，信息化跨平台系统设计等，从而实现降本提效</div>
      </div>
    </div>
    <div class="my-image-wrap">
      <div class="my-image">
        <div class="my-image-item">
          <a  class="nav-skip">
            <img src="@/assets/solutions/pice1.png" alt="">
            <div class="image-title">
              <div class="image-icon">
                <img src="@/assets/solutions/icon1.png" alt="">
              </div>
              <div class="image-font">
                人力资源系统案例
              </div>
            </div>
          </a>
        </div>
        <div class="my-image-item">
          <a class="nav-skip">
            <img src="@/assets/solutions/pice2.png" alt="">
            <div class="image-title">
              <div class="image-icon">
                <img src="@/assets/solutions/icon2.png" alt="">
              </div>
              <div class="image-font">
                教育后台展示案例
              </div>
            </div>
          </a>
        </div>
        <div class="my-image-item">
          <a class="nav-skip">
            <img src="@/assets/solutions/pice3.png" alt="">
            <div class="image-title">
              <div class="image-icon">
                <img src="@/assets/solutions/icon3.png" alt="">
              </div>
              <div class="image-font">
                网盘设计案例
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="my-offer">
      <div class="my-offer-tops">标准化设计服务流程</div>
      <div class="my-offer-footer">
        <div class="context">我们拥有一群在不同行业深耕多年的优秀设计师，善于深入业务，提供专业化的定制设计服务，打造高品质专属于您的视觉设计</div>
      </div>
    </div>
    <div class="my-standard">
      <div class="my-standard-item">
        <div class="standard-image">
          <img src="@/assets/solutions/standard1.png" alt="">
        </div>
        <div class="standard-top">聆听，创造，分享</div>
        <div class="standard-bottom">
          <div class="context">我们提供全方位服务，由咨询、设计、开发以至分析都一</div>
          <div class="context">应俱全，把技术全面实现在您的业务上</div>
        </div>
      </div>
      <div class="my-standard-item">
        <div class="standard-image">
          <img src="@/assets/solutions/standard2.png" alt="">
        </div>
        <div class="standard-top">一对一咨询</div>
        <div class="standard-bottom">
          <div class="context">准确了解您的想法和需要，我们的专业团队为您的商业计</div>
          <div class="context">划度身制定一套合适的设计方案</div>
        </div>
      </div>
      <div class="my-standard-item">
        <div class="standard-image">
          <img src="@/assets/solutions/standard3.png" alt="">
        </div>
        <div class="standard-top">设计及开发</div>
        <div class="standard-bottom">
          <div class="context">从后端系统整合到前端开发，我们的设计都是一丝不苟，</div>
          <div class="context">务求每个界面都能带来极致的用户体验</div>
        </div>
      </div>
    </div>
    <div class="my-offer">
      <div class="my-offer-tops-footer">我们一起成就彼此的梦想</div>
      <div class="my-offer-footer">
        <div class="context">不辜负每一位客户的信任，实现价值共赢</div>
      </div>
    </div>
    <div class="my-logo">
      <div class="my-logo-top">
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo1.png" class="logo logo-item" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo2.png" class="logo" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo3.png" class="logo" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo4.png" class="logo logo-item" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo10.png" class="logo" alt="">
        </div>
      </div>
      <div class="my-logo-footer">
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo5.png" class="logo" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo6.png" class="logo " alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo7.png" class="logo" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo8.png" class="logo logo-item" alt="">
        </div>
        <div class="my-logo-item">
          <img src="@/assets/solutions/logo9.png" class="logo logo-item" alt="">
        </div>
      </div>
      <div class="my-talk">
        <div class="my-talk-title">让我们合作，一起聊聊吧！</div>
      </div>
      <div class="my-cooperation">
        <div class="my-cooperation-content">
          <div class="my-cooperation-left">
            <div class="cooperation-img">
              <img src="@/assets/solutions/cooperation1.png" alt="">
            </div>
            <div class="cooperation-title">苏州</div>
            <div class="cooperation-number">18629667711</div>
            <div class="cooperation-address">中国（江苏）自由贸易试验区苏州片区苏州工业园区裕新路168号脉山龙大厦1幢409-4</div>
          </div>
          <!-- <div class="my-cooperation-right">
            <div class="cooperation-img">
              <img src="@/assets/solutions/cooperation2.png" alt="">
            </div>
            <div class="cooperation-title right">烟台</div>
            <div class="cooperation-number right">18888888888</div>
            <div class="cooperation-address right">山东省烟台市莱山区蓝色智谷13号楼3楼</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      index: '1'
    }
  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
.devise-wrap {
  // margin-top: 76px;
}
.top-wrap {
  width: 100%;
  height: 440px;
  background-color: #FAFBFC;
  display: flex;
  justify-content: center;
}
.top-context {
  margin-top: 36px;
  width: 1200px;
  height: 345px;
  text-align: center;
  background: #FAFBFC;
}
.context-top {
  margin-top: 41px;
  margin-left: 56px;
  width: 1200px;
  height: 77px;
  display: flex;
}
.context-center {
  margin-left: 148px;
  width: 846px;
  height: 132px;
  font-size: 94px;
  line-height: 132px;
}
.context-bottom {
  width: 1000px;
  height: 87px;
  display: flex;
  margin-left: 152px;
}
.left-png {
  font-size: 120px;
  margin-top: 29px;
  margin-left: 20px;
  height: 120px;
  color: #172B4D;
}
.left-words {
  width: auto;
  margin-left: 32px;
  margin-top: 60px;
  font-size: 24px;
  color: #172B4D;
}
.left-hello {
  width: 210px;
  height: 138px;
  margin-left: 370px;
  margin-top: -10px;
}
.bottom-english {
  width: auto;
  height: 87px;
  text-align: left;
  font-size: 62px;
  line-height: 87px;
  color: #0052CC;
}
.bottom-png {
  font-size: 120px;
  margin-top: 34px;
  margin-left: 20px;
  height: 120px;
  color: #172B4D;
}
.devise-Wrap {
  height: 156px;
  display: flex;
  justify-content: center;
  background: #FFFFFF;
}
.my-devise {
  width: 1200px;
  height: 156px;
  display: flex;
  justify-content: space-between;
  background: #FFFFFF;
}
.my-devise-item {
  margin-top: 51px;
  text-align: center;
  width: 10%;
}
.item-png {
  text-align: center;
  height: 49px;
}
.item-title {
  margin-top: 27px;
  text-align: center;
  height: 33px;
  font-size: 24px;
  line-height: 28px;
  color: #253858;
}
.my-offer {
  background: #FFFFFF;
  height: 304px;
  padding-top: 124px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.my-offer-top {
  width: 252px;
  height: 50px;
  font-size: 36px;
  line-height: 42px;
  color: #172B4D;
}
.my-offer-footer {
  width: 1200px;
  height: 53px;
  background: #FFFFFF;
  margin-top: 6px;
  font-size: 18px;
  line-height: 28px;
  color: #42526E;
}
.my-offer-footer .context {
  text-align: center;
}
.my-hover {
  width: 100%;
  height: 624px;
  display: flex;
  justify-content: center;
  background: #091E42;
}
.my-hover-wrap {
  width: 1200px;
  height: 624px;
  text-align: left;
  display: flex;
}
.my-hover-left {
  width: 520px;
  height: 624px;
}
.my-hover-right {
  width: 920px;
  height: 624px;
  display: flex;
}
.hover-wrap {
  width: 336px;
  height: 321px;
  margin-top: 88px;
  border-top: 2px solid #FFFFFF;
}
.hover-left-title {
  margin-top: 16px;
  width: 336px;
  height: 84px;
  font-size: 60px;
  line-height: 60px;
  color: #FFFFFF;
}
.hover-left-num {
  margin-top: 19px;
  width: 336px;
  height: 33px;
  font-size: 24px;
  line-height: 32px;
  color: #FFFFFF;
}
.hover-left-context {
  margin-top: 17px;
  width: 336px;
  height: 67px;
  font-size: 14px;
  line-height: 22px;
  color: #FFFFFF;
}
.hover-right-item {
  width: 400px;
  height: 624px;
  background: #FAFBFC;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user {
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/userbig.png');
  background-size: 400px 416px;
}
.user:hover, .my-hover .user_hov {
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/userbig.png');
  background-size: 400px 416px;
  transition: 0.3s all linear;
}
.interactive{
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/interactivebig.png');
  background-size: 400px 416px;
}

.interactive:hover, .my-hover .interactive_hov {
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/interactivebig.png');
  background-size: 400px 416px;
  transition: 0.3s all linear;
}
.vision{
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/visionbig.png');
  background-size: 400px 416px;
  transition:all 0.3s
}

.vision:hover, .my-hover .vision_hov {
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/visionbig.png');
  background-size: 400px 416px;
  transition: 0.3s all linear;
}
.implement{
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/implementbig.png');
  background-size: 400px 416px;
  transition:all 0.3s
}

.implement:hover, .my-hover .implement_hov {
  width: 100%;
  height: 500px;
  background: #172B4D;
  background-image: url('~@/assets/solutions/implementbig.png');
  background-size: 400px 416px;
  transition: 0.3s all linear;
}
.right-item {
  width: 100%;
  height: 312px;
  background: #091E42;
  display: flex;
}
.hover-context {
  margin-top: 99px;
  margin-left: 33px;
  width: 224px;
  height: 114px;
}
.hover-context-top {
  width: 224px;
  height: 33px;
  font-size: 24px;
  line-height: 32px;
  color: #FFFFFF;
}
.hover-context-bottom {
  width: 224px;
  height: 64px;
  margin-top: 17px;
  font-size: 14px;
  line-height: 22px;
  color: #FFFFFF;
}
.big {
  margin-left: 32px;
  margin-top: 32px;
  width: 336px;
  height: 114px;
  color: #FFFFFF;
  background: #172B4D;
}
.a-top {
  width: 224px;
  height: 33px;
  font-size: 24px;
  line-height: 32px;
}
.a-bottom {
  margin-top: 17px;
  width: 335px;
  height: 64px;
  margin-top: 17px;
  font-size: 14px;
  line-height: 22px;
}
.hover-icon {
  margin-top: 105px;
  margin-left: 33px;
  width: 78px;
  height: 79px;
}
.hover-right-item {
  width: 400px;
  height: 624px;
  background: #FAFBFC;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item-png img {
  height: 49px;
}
.my-offer-tops {
  width: 324px;
  height: 50px;
  font-size: 36px;
  line-height: 42px;
  color: #172B4D;
}
.my-image-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #FFFFFF;
}
.my-image {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
.my-image-item {
  width: 33%;
  height: auto;
}
.my-image-item img {
  width: 100%;
  height: auto;
}
.image-title {
  width: 400px;
  height: 50px;
  margin-top: -50px;
  margin-left: 30px;
  display: flex;
}
.image-icon {
  width: 28px;
  height: 28px;
}
.my-standard {
  display: flex;
  justify-content: center;
  background-color: #FFFFFF;
}
.my-standard-item {
  height: 195px;
  width: 420px;
  text-align: center;
}
.standard-image {
  text-align: center;
  height: 64px;
}
.standard-top {
  margin-top: 39px;
  text-align: center;
  height: 33px;
  font-size: 24px;
  line-height: 28px;
  color: #253858;
}
.standard-bottom {
  margin-top: 17px;
  width: 420px;
  text-align: center;
  height: 42px;
  font-size: 14px;
  line-height: 22px;
  color: #42526E;
}
.standard-image img {
  height: 64px;
  border: none;
  display: inline-block;
  vertical-align: middle;
}
.standard-bottom .context {
  text-align: center;
}
.my-offer-tops-footer {
  width: 396px;
  height: 50px;
  font-size: 36px;
  line-height: 42px;
  color: #172B4D;
}
.my-logo {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FFFFFF;
}
.my-logo-top {
  width: 1200px;
  height: 80px;
  display: flex;
  justify-content: center;
}
.my-logo-item {
  width: 214px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 32px;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px #d7dbdf;
  border-radius: 3px;
}
.my-logo-footer {
  width: 1200px;
  height: 80px;
  margin-top: 32px;
  display: flex;
  justify-content: center;
}
.logo {
  width: 150px;
  height: auto;
}
.logo-item {
  height: 50px;
}
.my-talk {
  background: #FFFFFF;
  height: 102px;
  margin-top: 133px;
  display: flex;
  justify-content: center;
}
.my-talk-title {
  width: 432px;
  height: 50px;
  font-size: 36px;
  line-height: 42px;
  color: #172B4D;
}
.my-cooperation {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #FFFFFF;
  height: 400px;
}
.my-cooperation-content {
  width: 1200px;
  display: flex;
  justify-content: center;
}
.my-cooperation-left {
  width: 588px;
  height: 336px;
  margin-left: 24px;
  background: #FAFBFC;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.my-cooperation-right {
  width: 588px;
  height: 336px;
  margin-left: 24px;
  background: #253858;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cooperation-img {
  margin-top: 64px;
  width: 64px;
  height: 64px;
}
.cooperation-img img {
  width: 100%;
  height: 100%;
}
img {
  border: none;
  vertical-align: middle;
  display: inline-block;
}
.cooperation-title {
  margin-top: 39px;
  width: auto;
  height: 33px;
  font-size: 24px;
  line-height: 32px;
  color: #172B4D;
}
.cooperation-number {
  margin-top: 7px;
  width: auto;
  height: 33px;
  font-size: 24px;
  line-height: 32px;
  color: #172B4D;
}
.cooperation-address {
  margin-top: 9px;
  width: auto;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 24px;
  color: #5E6C84;
}
.my-cooperation-right .right {
  color: #FFFFFF;
}
.image-font {
  margin-left: 8px !important;
  width: 324px !important;
  height: 50px !important;
  font-size: 26px !important;
  line-height: 26px !important;
  color: #172B4D !important;
}
.use1{
  width: 100%;
  height: 312px;
  background-color: #091E42;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/index.vue